import { formatInTimeZone } from 'date-fns-tz';
import { ISODate } from '@amzn/storm-ui-date-picker';
import { ISO_DATE_FORMAT } from '@flexible-reports/components/date-input/utils/constants';

const ONE_THOUSAND = 1000;
const ONE_MILLION = 1000000;

const ONE_MEGABYTE = Math.pow(1024, 2);
const ONE_GIGABYTE = Math.pow(1024, 3);

export const formatNumber = (num: number): string => {
  return new Intl.NumberFormat('en-US').format(num);
};

export const convertDatesToDatePeriod = (startDate: Date | null, endDate: Date | null) => {
  return startDate && endDate
    ? {
        startDate: formatInTimeZone(startDate, 'UTC', ISO_DATE_FORMAT) as ISODate,
        endDate: formatInTimeZone(endDate, 'UTC', ISO_DATE_FORMAT) as ISODate
      }
    : null;
};

export const formatRowCountBucket = (rowCount: number): string => {
  const bucketCategory = getBucketCategoryForRows(rowCount);
  return `${bucketCategory}`;
};

const getBucketCategoryForRows = (rowCount: number): string => {
  if (rowCount < 250 * ONE_THOUSAND) {
    return '< 250K rows';
  } else if (rowCount < ONE_MILLION) {
    return '250K-1M rows';
  } else {
    return '> 1M rows';
  }
};

export const formatFileSizeBucket = (bytes: number): string => {
  const bucketCategory = getBucketCategoryForFileSize(bytes);
  return `${bucketCategory}`;
};

const getBucketCategoryForFileSize = (bytes: number): string => {
  const MB_50 = 50 * ONE_MEGABYTE;
  const MB_500 = 500 * ONE_MEGABYTE;
  const GB_2 = 2 * ONE_GIGABYTE;
  const GB_5 = 5 * ONE_GIGABYTE;
  const GB_15 = 15 * ONE_GIGABYTE;
  const GB_24 = 24 * ONE_GIGABYTE;

  if (bytes < MB_50) {
    return '< 50MB';
  } else if (bytes < MB_500) {
    return '50MB-500MB';
  } else if (bytes < GB_2) {
    return '500MB-2GB';
  } else if (bytes < GB_5) {
    return '2GB-5GB';
  } else if (bytes < GB_15) {
    return '5GB-15GB';
  } else if (bytes < GB_24) {
    return '15GB-24GB';
  } else {
    return '> 24GB';
  }
};
